'use client';

import { createContext, useContext } from 'react';
export interface ImportQueueRailContextValue {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
}
export const ImportQueueRailContext = createContext<ImportQueueRailContextValue | null>(null);
export function useImportQueueRail(): ImportQueueRailContextValue {
  const ctx = useContext(ImportQueueRailContext);
  if (!ctx) {
    throw new Error('useImportQueueRail must be used within ImportQueueRailProvider');
  }
  return ctx;
}